export var TypographyTag;
(function (TypographyTag) {
    TypographyTag["caption"] = "caption";
    TypographyTag["h1"] = "h1";
    TypographyTag["h2"] = "h2";
    TypographyTag["h3"] = "h3";
    TypographyTag["h4"] = "h4";
    TypographyTag["h5"] = "h5";
    TypographyTag["h6"] = "h6";
    TypographyTag["p"] = "p";
    TypographyTag["span"] = "span";
    TypographyTag["figcaption"] = "figcaption";
})(TypographyTag || (TypographyTag = {}));
export var TypographySize;
(function (TypographySize) {
    TypographySize[TypographySize["_1"] = 1] = "_1";
    TypographySize[TypographySize["_2"] = 2] = "_2";
    TypographySize[TypographySize["_3"] = 3] = "_3";
    TypographySize[TypographySize["_4"] = 4] = "_4";
    TypographySize[TypographySize["_5"] = 5] = "_5";
    TypographySize[TypographySize["_6"] = 6] = "_6";
    TypographySize[TypographySize["_7"] = 7] = "_7";
    TypographySize[TypographySize["_8"] = 8] = "_8";
    TypographySize[TypographySize["_9"] = 9] = "_9";
})(TypographySize || (TypographySize = {}));
